export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/ucenter/system/menus',
      method: 'GET'
    }]
  },
  add: {
    funKey: 'add',
    name: '新增',
    apis: [{
      path: '/ucenter/system/menus',
      method: 'POST'
    },
    {
      path: '/ucenter/system/funs',
      method: 'POST'
    },
    {
      path: '/ucenter/system/funs/{funId}',
      method: 'PUT'
    },
    {
      path: '/ucenter/system/funs/{funId}',
      method: 'DELETE'
    }]
  },
  update: {
    funKey: 'edit',
    name: '修改',
    apis: [{
      path: '/ucenter/system/menus/{menuId}',
      method: 'PUT'
    },
    {
      path: '/ucenter/system/funs',
      method: 'POST'
    },
    {
      path: '/ucenter/system/funs/{funId}',
      method: 'PUT'
    },
    {
      path: '/ucenter/system/funs/{funId}',
      method: 'DELETE'
    }]
  },
  update_fun: {
    funKey: 'update_fun',
    name: '功能更新',
    apis: [{
      path: '/ucenter/system/funs',
      method: 'POST'
    },
    {
      path: '/ucenter/system/funs/{funId}',
      method: 'PUT'
    },
    {
      path: '/ucenter/system/funs/{funId}',
      method: 'DELETE'
    }]
  },
  del: {
    funKey: 'del',
    name: '删除',
    apis: [{
      path: '/ucenter/system/menus/{menuId}',
      method: 'DELETE'
    }]
  }
}